import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Table } from 'reactstrap';
import LogService from '../Services/LogService/logService';
import { withRouter } from "react-router-dom";
import { Badge } from 'mdbreact';
import { faEye } from '../../node_modules/@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  column: {
    flexBasis: '200.33%',
  },
});


class ControlledExpansionPanels extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: null,
      CompanyList: { pedding: false, value: [] },
      ChannelList: { channelpedding: false, channelvalue: [] },
      Filter: {
        FilterStartDate: null,
        FilterEndDate: null
      },
    };
    this.getUrlLog = this.getUrlLog.bind(this);
  }


  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  change = false;
  componentWillReceiveProps(nextProps) {

    if (this.props.StartDate !== nextProps.StartDate) {
      this.setState(state => {
        this.change = true;
        state.Filter.FilterStartDate = nextProps.StartDate;
        return state;
      });
    }

    if (this.props.EndDate !== nextProps.EndDate) {
      this.setState(state => {
        this.change = true;
        state.Filter.FilterEndDate = nextProps.EndDate;
        return state;
      });
    }

    if (this.change || (nextProps.StartDate == null && nextProps.EndDate == null)) {
      this.getCompany();
      this.change = false;
    }
  }

  getCompany() {

    let dataResult = LogService.getAllCompany(this.state.Filter.FilterStartDate, this.state.Filter.FilterEndDate);

    var that = this;

    dataResult.then(function (data) {

      that.setState({
        CompanyList: { pending: false, value: data.data }
      });
    })
  }
  componentDidMount() {
  }

  getUrlLog(companyCode) {
    this.props.history.push({
      pathname: '/log',
      state: { details: { companyCode: companyCode, startdate: this.state.Filter.FilterStartDate, enddate: this.state.Filter.FilterEndDate } }
    });

  }
  getUrlLogCompany(company, channel) {

    this.props.history.push({
      pathname: '/log',
      state: { details: { companyCode: company, channel: channel, startdate: this.state.Filter.FilterStartDate, enddate: this.state.Filter.FilterEndDate } }
    });

  }

  render() {
    const { classes } = this.props;
    const { expanded } = this.state;


    return (
      <div className={classes.root}>
        {
          this.state.CompanyList.value.map((item, index) => {
            return <ExpansionPanel key={index} expanded={expanded === index} onChange={this.handleChange(index)}>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <div className={classes.column}>           
                  <div className="row classes.heading" style={{'marginRight': '0px'}}>
                    <div className="col-10">Company:{item.company}</div>
                    <div className="col-1"><a onClick={e => this.getUrlLog(item.company)}><Badge color="warning"><FontAwesomeIcon icon={faEye} /></Badge></a></div>
                  </div>        
                </div>
                <div className={classes.column}>
                  <Typography className={classes.secondaryHeading}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total Log: {item.totalCompany}</Typography>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <div >
                  <Table responsive striped hover >
                    <thead>
                      <tr>
                        <th>Channel</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.getChannelList(item.channel_result, item.company)}
                    </tbody>
                  </Table>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          })
        }
      </div>
    );
  }
  getChannelList(item, company) {
    return item.map((i, index) => {
      let ret = <tr key={index} >
        <td style={{ 'paddingTop': '0.4rem', 'paddingBottom': '0.4rem' }}><a onClick={e => this.getUrlLogCompany(company, i.Channel)}><span className="badge badge-pill badge-light">{i.Channel}</span></a></td>
        <td style={{ 'paddingTop': '0.4rem', 'paddingBottom': '0.4rem' }}>{i.total}</td>
      </tr>;

      return ret;
    })
  }
}


ControlledExpansionPanels.propTypes = {
  classes: PropTypes.object.isRequired,
  StartDate: PropTypes.string,
  EndDate: PropTypes.string
};

export default withRouter(withStyles(styles)(ControlledExpansionPanels));


// WEBPACK FOOTER //
// ./src/log/CompanyList.jsx